import { render, staticRenderFns } from "./ResourceScroller.MovieBox.vue?vue&type=template&id=c1bc5828&scoped=true&"
import script from "./ResourceScroller.MovieBox.vue?vue&type=script&lang=js&"
export * from "./ResourceScroller.MovieBox.vue?vue&type=script&lang=js&"
import style0 from "./ResourceScroller.MovieBox.vue?vue&type=style&index=0&id=c1bc5828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc5828",
  null
  
)

export default component.exports